module.exports = __webpack_public_path__ + "static/media/office.d8a419ad.jpg";